import { Vector2 } from "three";
import { DOMHitTest } from "./DOMHitTest";
import { ElementType } from "./ElementType";

export class ElementContainerElement<E extends Element> extends Element
{
  __elementContainer__:ElementContainer<E>;
}

export class ElementContainer<E extends Element>
{
  protected _element:ElementContainerElement<E>;
  get element(){ return this._element as any as E}  
  get htmlElement(){ return this._element as any as HTMLElement }

  protected _createElement( type:ElementType<E>, content?:string|Node|(string|Node)[], doc?:Document  )
  {
    this._element = type.create( content, doc ) as any as ElementContainerElement<E>;
    this._element.__elementContainer__ = this;
  }

  protected _setElement( e:ElementContainerElement<E> )
  {
    this._element = e;
    this._element.__elementContainer__ = this;
  }

  clearChildren()
  {
    this._element.innerHTML = "";
  }

  appendChild( container:ElementContainer<any> )
  {
    this._element.appendChild( container.element );
  }

  appendType( elementType:ElementType<any> )
  {
    this._element.appendChild( elementType.create() );
  }

  appendBreak()
  {
    this.appendType( ElementType.break );
  }

  setElementPositionFrom( e:MouseEvent, offset?:Vector2 )
  {
    let position = DOMHitTest.getPointerPosition( e );
    
    if ( offset )
    {
      position.add( offset );
    }

    this.setElementPosition( position );
  }

  setElementPosition( position:Vector2 )
  {
    this.htmlElement.style.left = position.x + "px";
    this.htmlElement.style.top  = position.y + "px";
  }
}